export type ChatParticipantOption = {
  label: string;
  value: string;
};

export type CurrentChatUser = {
  id: string;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  username?: string | null;
};

export function shouldDefaultParticipantToCurrentUser(
  userIdQueryParams: string[] | null
): boolean {
  return userIdQueryParams === null;
}

export function getDefaultParticipantUserIds({
  currentUserId,
  selectedParticipantIds,
  userIdQueryParams,
}: {
  currentUserId?: string;
  selectedParticipantIds: string[];
  userIdQueryParams: string[] | null;
}): string[] {
  if (selectedParticipantIds.length > 0) {
    return selectedParticipantIds;
  }
  if (
    currentUserId &&
    shouldDefaultParticipantToCurrentUser(userIdQueryParams)
  ) {
    return [currentUserId];
  }
  return [];
}

export function getChatThreadParticipantUserIds({
  currentUserId,
  isCompact,
  selectedParticipantIds,
}: {
  currentUserId?: string;
  isCompact: boolean;
  selectedParticipantIds: string[];
}): string[] | undefined {
  if (isCompact) {
    return currentUserId ? [currentUserId] : undefined;
  }
  return selectedParticipantIds.length > 0 ? selectedParticipantIds : undefined;
}

export function participantOptionsWithCurrentUser(
  options: ChatParticipantOption[],
  currentUser?: CurrentChatUser | null
): ChatParticipantOption[] {
  if (!currentUser?.id) {
    return options;
  }
  if (options.some((option) => option.value === currentUser.id)) {
    return options;
  }
  return [
    {
      label: currentUserParticipantLabel(currentUser),
      value: currentUser.id,
    },
    ...options,
  ];
}

function currentUserParticipantLabel(user: CurrentChatUser): string {
  const fullName = [user.firstName, user.lastName]
    .filter(Boolean)
    .join(' ')
    .trim();
  return fullName || user.username || user.email || user.id;
}
